import { cva } from "class-variance-authority";

export const statusIcon = cva("h-6 w-6 flex-shrink-0", {
  variants: {
    variant: {
      neutral: "text-interactive-icon-idle",
      success: "stroke-info-success text-info-success",
      warning: "stroke-info-warning text-info-warning",
      error: "stroke-info-error text-info-error",
    },
  },
  defaultVariants: {
    variant: "neutral",
  },
});

export const statusSeparator = cva("h-px t:h-auto t:w-px flex-shrink-0 self-stretch", {
  variants: {
    variant: {
      neutral: "bg-elevation-outline-1",
      success: "bg-info-success-outline",
      warning: "bg-info-warning-outline",
      error: "bg-info-error-outline",
    },
  },
  defaultVariants: {
    variant: "neutral",
  },
});

export type StatusAction = {
  text: string;
  onPress: () => void;
  className?: string;
};

export type StatusParams = {
  text: string;
  isLoading?: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  actions?: StatusAction[];
};
